var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"store-name"},[_vm._v(_vm._s(_vm.store.name))]),_c('hr',{staticClass:"divider"}),_c('div',{staticClass:"store-info"},[_c('h3',[_vm._v(_vm._s(_vm.store.address))]),_c('h3',[_vm._v(_vm._s(_vm.store.phone))])])])}
var staticRenderFns = []

export { render, staticRenderFns }